import { surveyManagementFeature } from './survey-management.feature';

export const {
  selectBuyerProjectManagerUpdating,
  selectOperatorProjectManagerUpdating,
  selectError,
  selectSurveyManagementState,
} = surveyManagementFeature;
